
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"icons","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 12"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"cls-1",attrs:{"id":"cross","d":"M7.41 6l2.13 2.12a1 1 0 01-1.42 1.42L6 7.41 3.88 9.54a1 1 0 01-1.42-1.42L4.59 6 2.46 3.88a1 1 0 011.42-1.42L6 4.59l2.12-2.13a1 1 0 011.42 1.42L7.41 6z"}})])
          )
        }
      }
    